<template>
  <modal
    name="contact-form"
    :minHeight="370"
    :width="480"
    :height="'auto'"
    :adaptive="true"
    :scrollable="true"
    :draggable="false"
    :clickToClose="true"

  >
   <div class="contact-form-vox">
      <div class="contact-form-vox__close" @click.stop.prevent="closeModal">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
          <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
        </svg>
      </div>
      <h3 class="contact-form-vox__title mt-1">Zapytaj o ofertę</h3>
      <div v-if="advisor" class="contact-form-vox__advisor-info">
        <img
          v-if="advisor.photo"
          :src="advisor.photo"
          :alt="advisor.name || 'Doradca klienta'"
          class="contact-form-vox__advisor-photo"
        />
        <div class="contact-form-vox__advisor-details">
          <h4 v-if="advisor.name">{{ advisor.name }}</h4>
          <p v-if="advisor.position">{{ advisor.position }}</p>
          <a
            v-if="modalAdvisorPhone"
            :href="'tel:' + sanitizePhone(modalAdvisorPhone)"
            class="contact-form-vox__advisor-phone"
          >
            {{ modalAdvisorPhone }}
          </a>
        </div>
      </div>
      <form class="contact-form-vox__form mb-1" @submit.prevent="submitForm">
        <div class="contact-form-vox__group">
          <input
            class="contact-form-vox__input"
            type="text"
            v-model="formData.contact_name"
            placeholder="Imię i nazwisko *"
            @change="checkForm()"
          />
          <span class="contact-form-vox__error" v-if="nameError">{{ nameError }}</span>
        </div>
        <div class="contact-form-vox__group">
          <input
            class="contact-form-vox__input"
            type="text"
            v-model="formData.contact_email"
            placeholder="Email *"
             @change="checkForm()"
          />
          <span class="contact-form-vox__error" v-if="emailError">{{ emailError }}</span>
        </div>
        <div class="contact-form-vox__group">
          <input
            class="contact-form-vox__input"
            type="text"
            v-model="formData.contact_phone"
            placeholder="Telefon *"
             @change="checkForm()"
          />
          <span class="contact-form-vox__error" v-if="phoneError">{{ phoneError }}</span>
        </div>
        <div class="contact-form-vox__group">
          <textarea
            class="contact-form-vox__input"
            v-model="formData.contact_message"
            placeholder="Wiadomość"
          />
        </div>
        <div class="contact-form-vox__checkbox-group">
          <input class="contact-form-vox__checkbox" type="checkbox" id="zgoda1" v-model="formData.contact_acceptance1" @change="checkForm()"/>
          <label class="contact-form-vox__checkbox-label" for="zgoda1">
            Wyrażam zgodę na otrzymywanie informacji handlowych od Developme sp. z o.o.
            <span v-if="!showFullZgoda1" class="read-more-link" @click.prevent="showFullZgoda1 = true"> czytaj więcej</span>
            <span v-if="showFullZgoda1"> drogą elektroniczną na wskazany w formularzu numer telefonu oraz adres poczty elektronicznej.</span>
            <span v-if="showFullZgoda1" class="read-more-link" @click.prevent="showFullZgoda1 = false"> zwiń</span>
          </label>
        </div>
    
        <div class="contact-form-vox__checkbox-group">
          <input class="contact-form-vox__checkbox" type="checkbox" id="zgoda2" v-model="formData.contact_acceptance2" @change="checkForm()"/>
          <label class="contact-form-vox__checkbox-label" for="zgoda2">
            Wyrażam zgodę na marketing bezpośredni Developme sp. z o.o.
            <span v-if="!showFullZgoda2" class="read-more-link" @click.prevent="showFullZgoda2 = true"> czytaj więcej</span>
            <span v-if="showFullZgoda2"> przy użyciu telekomunikacyjnych urządzeń końcowych i automatycznych systemów wywołujących.</span>
            <span v-if="showFullZgoda2" class="read-more-link" @click.prevent="showFullZgoda2 = false"> zwiń</span>
          </label>
        </div>
  
        <div class="contact-form-vox__checkbox-group">
          <input class="contact-form-vox__checkbox" type="checkbox" id="zgoda3" v-model="formData.contact_acceptance3" @change="checkForm()"/>
          <label class="contact-form-vox__checkbox-label" for="zgoda3">
            Akceptuję treść <a :href="this.url + '/polityka-prywatnosci/'" target="_blank">Polityki Prywatności</a> Administratorem danych osobowych jest DevelopMe sp. z o.o.
            <span v-if="!showFullZgoda3" class="read-more-link" @click.prevent="showFullZgoda3 = true"> czytaj więcej</span>
            <span v-if="showFullZgoda3"> Dane osobowe będą przetwarzane w celu wskazanym w treści wyrażonej zgody, w celu realizacji zamówionego kontaktu, marketingu bezpośredniego własnych produktów i usług oraz obrony przed ewentualnymi roszczeniami oraz w celu wykonania obowiązków wynikających z przepisów prawa. Przysługuje Pani/Panu prawo do dostępu do danych, ich usunięcia, ograniczenia przetwarzania, przenoszenia, sprzeciwu, sprostowania oraz cofnięcia zgód w każdym czasie.</span>
            <span v-if="showFullZgoda3" class="read-more-link" @click.prevent="showFullZgoda3 = false"> zwiń</span>
          </label>
        </div>
        <span class="contact-form-vox__error" v-if="zgodyError">{{ zgodyError }}</span>
        <div v-if="success" class="contact-form-vox__success">Dziękujemy! Twoja wiadomość została wysłana.</div>
        <div v-if="error" class="contact-form-vox__error contact-form-vox__error--submit">{{ error }}</div>
  
        <div class="contact-form-vox__buttons"> <button type="submit" class="contact-form-vox__submit" :disabled="isSubmitting || success">{{ success ? 'Dziękujemy!' : (isSubmitting ? 'Wysyłanie...' : 'Wyślij zapytanie') }}</button>
          <button type="button" class="contact-form-vox__cancel" @click="closeModal()">Zamknij</button>
         
        </div>
      </form>
    </div>
  </modal>
</template>

<script>
import axios from "axios";
export default {
  props: {
    flat: {
      type: String,
      default: ""
    },
    advisor: {
      type: Object,
      default: null
    },
    advisorPhone: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      success: false,
      error: "",
      isSubmitting: false,
      successTimeout: null,
      holder: "",
      showFullZgoda1: false,
      showFullZgoda2: false,
      showFullZgoda3: false,
      formData: {
        contact_name: "",
        contact_email: "",
        contact_phone: "",
        contact_message: "Proszę o więcej informacji na temat lokalu " + this.flat,
        contact_flat: this.flat,
        contact_acceptance1: "",
        contact_acceptance2: "",
        contact_acceptance3: ""
      },
      nameError: "",
      emailError: "",
      phoneError: "",
      url: window.location.origin
      // url: "https://test.2qbs.pl"
    };
  },
  watch: {
    flat(newVal) {
      if (newVal) {
        this.formData.contact_message = "Proszę o więcej informacji na temat lokalu " + newVal;
        this.formData.contact_flat = newVal;
      }
    }
  },
  mounted() {
    // Blokuj scrollowanie tła po otwarciu modala
    this.$root.$on('modal:opened', () => {
      document.body.style.overflow = 'hidden';
    });
    
    // Przywróć scrollowanie po zamknięciu modala
    this.$root.$on('modal:closed', () => {
      document.body.style.overflow = '';
    });
  },
  beforeDestroy() {
    // Przywróć scrollowanie i usuń listenery
    document.body.style.overflow = '';
    this.$root.$off('modal:opened');
    this.$root.$off('modal:closed');
    if (this.successTimeout) {
      clearTimeout(this.successTimeout);
    }
  },
  methods: {
    sanitizePhone(value) {
      return String(value || '').replace(/\s+/g, '');
    },
    formatAdvisorPhone(value) {
      const raw = String(value || '').trim();
      if (!raw) return '';

      const digits = raw.replace(/\D+/g, '');
      if (!digits) return raw;

      if (digits.length === 9) {
        return digits.match(/.{1,3}/g).join(' ');
      }

      if (digits.length > 9) {
        const local = digits.slice(-9);
        const country = digits.slice(0, -9);
        if (country) {
          return `+${country} ${local.match(/.{1,3}/g).join(' ')}`;
        }
      }

      return raw;
    },
    closeModal() {
      document.body.style.overflow = '';
      this.$modal.hide("contact-form");
    },
    resetForm() {
      this.formData.contact_name = "";
      this.formData.contact_email = "";
      this.formData.contact_phone = "";
      this.formData.contact_message = "";
      this.formData.contact_flat = "";
      this.formData.contact_acceptance1 = "";
      this.formData.contact_acceptance2 = "";
      this.formData.contact_acceptance3 = "";
    },
    checkForm() {
      this.nameError = "";
  this.emailError = "";
  this.phoneError = "";
  this.zgodyError = "";
      this.error = "";
      if (!this.formData.contact_name) {
        this.nameError = "Pole jest obowiązkowe"
        return false
      } else { this.nameError = "" }
        // Sprawdzenie poprawności e-maila
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailPattern.test(this.formData.contact_email)) {
    this.emailError = "Podaj poprawny adres e-mail";
    return false;
      } else {
        this.emailError = "";
      }
      if (!this.formData.contact_phone) {
        this.phoneError = "Pole jest obowiązkowe"
        return false
      }
      const phoneDigits = this.formData.contact_phone.replace(/\D/g, "");
if (phoneDigits.length < 9) {
  this.phoneError = "Numer zawiera co najmniej 9 cyfr";
  return false;
} else {
  this.phoneError = "";
}
if (
    !this.formData.contact_acceptance1 ||
    !this.formData.contact_acceptance2 ||
    !this.formData.contact_acceptance3
  ) {
    this.zgodyError = "Zaznaczenie wszystkich zgód jest obowiązkowe";
    return false;
  } else {
    this.zgodyError = "";
  }

    },
    submitForm() {
      // console.log('testtest')
      // console.log(this.formData)
      if (this.checkForm() != false) {
        this.isSubmitting = true;
        this.error = "";
        this.success = false;
        axios
          .post(this.url + `/wp-json/twoqbs/v1/send`, this.formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((res) => {
            this.success = true;
            console.log(res);
            this.resetForm();
            if (this.successTimeout) {
              clearTimeout(this.successTimeout);
            }
            this.successTimeout = setTimeout(() => {
              this.success = false;
              this.closeModal();
            }, 2000);
          })
          .catch((err) => {
            this.success = false;
            console.log(err);
            this.error = "Wystąpił błąd podczas wysyłania wiadomości.";
          })
          .finally(() => {
            this.isSubmitting = false;
          });
      }
    },
  },
  computed: {
    modalAdvisorPhone() {
      return this.formatAdvisorPhone(this.advisorPhone || this.advisor?.phone || '');
    }
  }
};
</script>

<style>
/* .contact-form-vox * { box-sizing: border-box !important; font-family: Arial, Helvetica, sans-serif !important; } */

.contact-form-vox {
  background: #fff;
  padding: 32px 16px 16px;
  border-radius: var(--border-radius, 16px);
  border: 1px solid var(--main-color, #000000);
  max-width: 500px;
  width: 100%;
  min-width: 280px;
  margin: 0 auto;
  position: relative;
  display: block;
  box-sizing: border-box;
}

.contact-form-vox__close {
  position: absolute;
  right: 10px;
  top: 10px;
  cursor: pointer;
  z-index: 1000000;
  background: white;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
}

.contact-form-vox__close svg {
  pointer-events: none;
}

.contact-form-vox__close:active {
  transform: scale(0.95);
}

.contact-form-vox__title {
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 14px;
  color: #222222;
  text-align: center;
}

.contact-form-vox__form {
  width: 100%;
}

.contact-form-vox__advisor-info {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 14px;
}

.contact-form-vox__advisor-photo {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  object-fit: cover;
  flex: 0 0 72px;
}

.contact-form-vox__advisor-details {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.contact-form-vox__advisor-details h4 {
  margin: 0;
  font-size: 16px;
  color: #222222;
}

.contact-form-vox__advisor-details p {
  margin: 2px 0 0;
  font-size: 13px;
  color: #666666;
}

.contact-form-vox__advisor-phone {
  margin-top: 2px;
  color: var(--main-color, #000000);
  font-size: 16px;
  font-weight: 700;
  text-decoration: none;
}

.contact-form-vox__advisor-phone:hover {
  text-decoration: underline;
}

.contact-form-vox__group {
  margin-bottom: 18px;
}

.contact-form-vox__label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 6px;
  color: #222;
  line-height: 1.3;
}

.contact-form-vox__required {
  color: red;
  font-size: 14px;
  margin-left: 2px;
}

.contact-form-vox__input {
  width: 100% !important;
  min-width: 0 !important;
  padding: 10px 12px !important;
  font-size: 14px !important;
  line-height: 1.35 !important;
  border: 1px solid var(--main-color, #000000) !important;
  border-radius: var(--border-radius, 16px) !important;
  background: #ffffff !important;
  color: #222222 !important;
  margin-bottom: 2px !important;
  transition: border-color 0.2s, box-shadow 0.2s;
  outline: none !important;
  box-shadow: none !important;
  box-sizing: border-box !important;
  resize: none !important;
  -webkit-appearance: none !important;
  appearance: none !important;
}

.contact-form-vox__input:focus {
  border-color: var(--main-color, #000000) !important;
  box-shadow: 0 0 0 1px var(--main-color, #000000) !important;
}

.contact-form-vox__error {
  color: #d32f2f;
  font-size: 12px;
  margin-top: 2px;
  display: block;
}

.contact-form-vox__error--submit {
  margin-top: 8px;
}

.contact-form-vox__success {
  margin-top: 8px;
  padding: 10px 12px;
  border-radius: var(--border-radius, 16px);
  background: #e6f7ec;
  color: #1f7a39;
  font-size: 14px;
  font-weight: 600;
}

.contact-form-vox__checkbox-group {
  display: flex;
  align-items: flex-start;
  margin-bottom: 10px;
}

.contact-form-vox__checkbox {
  width: 15px !important;
  height: 15px !important;
  min-width: 15px !important;
  min-height: 15px !important;
  margin-right: 8px;
  margin-top: 2px;
  flex: 0 0 15px;
  padding: 0 !important;
  box-sizing: border-box !important;
  -webkit-appearance: none !important;
  appearance: none !important;
  border: 1px solid #bfc6cc !important;
  border-radius: 4px !important;
  background: #ffffff !important;
  display: inline-grid !important;
  place-content: center !important;
  transition: background-color 0.15s ease, border-color 0.15s ease;
  cursor: pointer;
}

.contact-form-vox__checkbox:checked {
  background: var(--main-color, #000000) !important;
  border-color: var(--main-color, #000000) !important;
}

.contact-form-vox__checkbox:checked::after {
  content: "";
  width: 7px;
  height: 4px;
  border-left: 2px solid #ffffff;
  border-bottom: 2px solid #ffffff;
  transform: rotate(-45deg) translateY(-1px);
}

.contact-form-vox__checkbox-label {
  font-size: 10px;
  color: #222;
  line-height: 1.4;
  font-weight: 400;
  user-select: text;
}

.contact-form-vox__checkbox-label a {
  color: #222;
  text-decoration: underline;
}

.read-more-link {
  color: var(--main-color, #000000);
  cursor: pointer;
  text-decoration: underline;
  font-weight: 500;
  user-select: none;
}

.read-more-link:hover {
  color: var(--main-color, #000000);
  opacity: 0.9;
}

.contact-form-vox__buttons {
  display: flex;
  gap: 12px;
  margin-top: 10px;
}

.contact-form-vox__cancel {
  flex: 1;
  background: #fff;
  color: var(--main-color, #000000);
  border: 1px solid var(--main-color, #000000);
  border-radius: var(--border-radius, 16px);
  padding: 12px 0;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.contact-form-vox__cancel:hover {
  background: #fff;
  opacity: 0.9;
}

.contact-form-vox__submit {
  flex: 1;
  background: var(--main-color, #000000);
  color: #fff;
  border: none;
  border-radius: var(--border-radius, 16px);
  min-height: 42px;
  padding: 12px 0;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s;
}

.contact-form-vox__submit:disabled {
  opacity: 0.7;
  cursor: default;
}

.contact-form-vox__submit:hover {
  opacity: 0.9;
}

.vm--overlay,
.vm--modal {
  z-index: 9999999 !important;
}

.vm--overlay {
  background-color: rgba(0, 0, 0, 0.5) !important;
}

/* Dodatkowe zabezpieczenie dla mobile */
@media (max-width: 767px) {
  .vm--modal {
    position: fixed !important;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
  }
  
  .contact-form-vox__close {
    width: 48px !important;
    height: 48px !important;
    right: 8px !important;
    top: 8px !important;
    z-index: 10000000 !important;
  }
  
  .contact-form-vox__close svg {
    width: 24px;
    height: 24px;
  }
}
</style>

